"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.emailProviderApi = emailProviderApi;
exports.expiryMagicLinkPasswordApi = expiryMagicLinkPasswordApi;
exports.recordsDetailsApi = recordsDetailsApi;
exports.recordsForgotPasswordApi = recordsForgotPasswordApi;
exports.recordsLoginApi = recordsLoginApi;
exports.recordsPublicDetailsApi = recordsPublicDetailsApi;
var _core = require("../../core/core.service");
var _app = _interopRequireDefault(require("../../../configs/app.config"));
var _tenant = require("../../../constants/endpoints/tenant");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// @flow

var api = new _core.APICore();

/**
 * Login
 * @param payload
 * @returns api response
 * @description this function used to user login by its credencials.
 */
function recordsLoginApi(params) {
  return api.create("".concat(_app.default.baseUrl + _tenant.RecordService.records), params);
}

/**
 * record details
 * @param payload
 * @returns api response
 * @description this function used to fetch details.
 */
function recordsDetailsApi(params) {
  return api.get("".concat(_app.default.baseUrl + _tenant.RecordService.details), params);
}

/**
 * record details
 * @param payload
 * @returns api response
 * @description this function used to fetch details.
 */
function recordsPublicDetailsApi(params) {
  return api.get("".concat(_app.default.baseUrl + _tenant.RecordService.publicDetails), params);
}

/**
 * Forgot Password
 * @param payload
 * @returns api response
 * @description this function used to user forgot password by its credencials.
 */
function recordsForgotPasswordApi(params) {
  var headersConfig = JSON.parse(sessionStorage.getItem("headersConfigForgotPassword"));
  return api.create("".concat(_app.default.baseUrl + _tenant.RecordService.forgotPassword), params, headersConfig);
}

/**
 * Forgot Password
 * @param payload
 * @returns api response
 * @description this function used to user forgot password by its credencials.
 */
function expiryMagicLinkPasswordApi(params) {
  return api.create("".concat(_app.default.baseUrl + _tenant.RecordService.expiryMagicLinkPassword), params);
}

/**
 * record exists or not
 * @param payload
 * @returns api response
 * @description this function used to check record exists or not.
 */
function emailProviderApi(params) {
  return api.update("".concat(_app.default.baseUrl + _tenant.RecordService.emailProvider), params);
}